module.exports = __webpack_public_path__ + "img/3-5.75a28b14.svg";